import React, { Component } from "react";

export default class IniciativaPopular extends Component {
  render() {
    return <div>IniciativaPopular</div>;
  }
}
